/**
 * Estilo canónico de las ACCIONES EN LÍNEA de `MasterDocument`.
 *
 * `MasterCrud` no usa texto subrayado para accionar: todo lo que hace algo es un botón con
 * su caja —borde, radio y fondo—, y el subrayado queda reservado a la navegación. En
 * `MasterDocument` había siete `<button>` pintados como enlaces (`hover:underline`), lo que
 * daba dos afordancias distintas para la misma cosa: «Actualizar», «Descruzar», «Cerrar»,
 * «Cancelar» y «Añadir documento origen» se leían como enlaces y no como acciones.
 *
 * Las medidas salen del canon medido en `/app/items` el 2026-09-04 —radio 6px, 12px/600, el
 * azul de marca #1355b7 sobre #eff8ff y el borde #93d1fd del hover— reducidas a la escala de
 * una micro-acción dentro de un panel (24px de alto en vez de los 36px del toolbar).
 *
 * Un solo sitio para el estilo: si viviera repetido en los siete ficheros, volvería a
 * divergir en el siguiente PR (ADR-027 §Apéndice C, «un solo dueño del estilo»).
 */

/** Caja común: geometría, tipografía y estados. No lleva color. */
const BASE =
  'inline-flex items-center gap-1 px-2 h-6 rounded-md border text-xs font-semibold ' +
  'transition-colors cursor-pointer select-none ' +
  'disabled:opacity-50 disabled:cursor-not-allowed ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400';

/** Acción secundaria: el azul de marca del canon. */
export const inlineActionButton = `${BASE} ` +
  'border-[#93d1fd] bg-[#eff8ff] text-[#1355b7] hover:bg-[#dbeefe] hover:border-[#3c9bf6] ' +
  'dark:border-primary-800 dark:bg-primary-900/20 dark:text-primary-300 dark:hover:bg-primary-900/40';

/** Acción destructiva o de descarte (descruzar, cancelar una conversión). */
export const inlineActionButtonDanger = `${BASE} ` +
  'border-[#fca5a5] bg-[#fee2e2] text-[#b91c1c] hover:bg-[#fecaca] hover:border-[#f87171] ' +
  'dark:border-red-800 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/40';

/** Acción neutra: cerrar un aviso, cancelar sin consecuencia. */
export const inlineActionButtonNeutral = `${BASE} ` +
  'border-border-primary bg-white text-content-secondary hover:bg-background-secondary ' +
  'dark:border-dark-border-primary dark:bg-dark-bg-primary dark:text-dark-content-secondary dark:hover:bg-dark-bg-secondary';
